import React, { useState, useEffect } from 'react';
import Image from 'next/image';
import closeIcon from '@/images/green-cross.svg';

import { Box } from '../../../Box';
import CtaWidget from '~/components/CtaWidget';
import { ILearningCenterStickySignupFields } from '../../../../../types/contentful';

export function MobileStickySignup({
  header,
  subheader,
  cta
}: ILearningCenterStickySignupFields) {
  const [ctaScrollPosition, setCtaScrollPosition] = useState(false);
  const [showSignup, setShowSignup] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 400) setCtaScrollPosition(true);
      else setCtaScrollPosition(false);
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return showSignup && ctaScrollPosition ? (
    <div
      className="fixed bottom-10 left-0 z-[3] w-full bg-transparent"
      data-testid="sticky-signup"
    >
      <div className="content-center items-center overflow-hidden rounded-3xl bg-[#99D8D8] p-5 shadow-md">
        <div className="column w-full flex-col !p-0">
          <h3 className="text-center text-[20px] font-semibold tracking-[.5px]">
            {header}
          </h3>

          <Box marginTop={{ 0: 's' }}>
            <p className="text-center text-[14px]">{subheader}</p>
          </Box>
          <div className="mt-2 flex items-center justify-center">
            <CtaWidget
              id="sticky-signup-cta"
              module="Sticky Signup"
              errorPosition="bottom"
              responsive
              {...cta?.fields}
              sysId={cta?.sys?.contentType?.sys?.id + 5}
            />
          </div>
          <button
            className="absolute right-4 top-0 inline-flex h-[50px] w-[50px] appearance-none items-center justify-center rounded-bl-popup rounded-tr-popup text-[#035C67] outline-none"
            aria-label="Close"
            data-testid="sticky-signup-close"
            onClick={() => setShowSignup(false)}
          >
            <Image src={closeIcon} alt="Close" width={28} height={28} />
          </button>
        </div>
      </div>
    </div>
  ) : null;
}
